import axios from 'axios';
import { showErrorToast } from "../utils/AlertUtils";

const API_URL = process.env.REACT_APP_API_URL;

const getHeaders = () => {
  const token = localStorage.getItem("token");
  if(!token) {
    localStorage.removeItem("token");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userDetails");
    showErrorToast("સેશન સમાપ્ત થયું. કૃપા કરીને ફરીથી લોગિન કરો.");
    setTimeout(() => {
      window.location.href = "/login";
    }, 500);
    return null;
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const ApiHelper = async (endpoint, method = "GET", body = null, extraOptions = {}) => {
  const headers = getHeaders();

  if (!headers) {
    return null; // API કોલ રદ કરો.
  }

  const options = {
    method,
    url: `${API_URL}${endpoint}`,
    headers: getHeaders(),
    ...extraOptions,
  };

  if (body) {
    options.data = body;
  }

  try {
    const response = await axios(options);

    // Check the response type and return the appropriate response
    if (response.headers['content-type'] === 'application/pdf' && extraOptions.responseType === 'blob') {
      return response; // Return the full response object for binary data
    }
    return response?.data;
  } catch (error) {
    console.error("API Error:", error);
    const errorMessage = error?.response?.data?.message || error?.message || "નેટવર્કમાં ભૂલ";
    if(error?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("userDetails");
      showErrorToast("સેશન સમાપ્ત થયું. કૃપા કરીને ફરીથી લોગિન કરો.");
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
      return;
    }
    throw new Error(errorMessage);
  }
};

export default ApiHelper;